import { API, Tag, TagsAPI } from "@brg/api";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { AppTester } from "supporting";
import { useController, useFormContext } from "react-hook-form";
import { MAX_TAG_COUNT } from "../../constants";
import TagsField from "shared/components/form/TagsField";
import { splitTags } from "../../helpers";
import { MAX_PLACES_TAG_COUNT } from "../../constants";

const TagSelect: FC<{ noLabel?: boolean }> = ({ noLabel }) => {
    const {
        t,
        i18n,
        i18n: { language },
    } = useTranslation();

    const { field: { value: selected = [], onChange } } = useController({ name: 'tags' });
    const { getValues, setValue } = useFormContext();

    const isGeograffee = AppTester.isGeograffee();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isBrnd = AppTester.isBrnd();

    const requiredTags = getValues('requiredTags');

    const isOneSelectedTag = selected?.length === 1
    return (
        <TagsField
            name="tags"
            label={t('project_edit.tags')}
            noLabel={noLabel}
            isProjectEdit
            isOneSelectedTag
            modalOptions={{
                educational: false,
                onChange: (tagsRaw: Tag[]) => {
                    if (isGeograffee) {
                        const { tags, cities } = splitTags(tagsRaw);
                        setValue('tags', tags);
                        setValue('cities', cities);
                    } else {
                        const tagIds = tagsRaw.map(tag => tag.tagId)
                        if (tagIds.length) {
                            TagsAPI.GetTags(({ tagIds, lang: i18n.language }))
                                .then((v) => v.json())
                                .then((v) => API.toLang<Tag[]>(v, language))
                                .then((tags) => onChange(tags));
                        }
                        onChange(tagsRaw);
                    }
                },
                hideGlobalSearchBar: isBrnd,
                maxEducationalTags: requiredTags?.length > 0 ? 0 : 1,
                maxProjectTags: MAX_TAG_COUNT,
                maxPlacesTags: MAX_PLACES_TAG_COUNT,
                protectedTags: isAgeytomesh ? [AGEYTOMESH_TAG_ID] : [],
            }}
        />
    );
};

export default TagSelect;import { API, Tag, TagsAPI } from "@brg/api";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { AppTester } from "supporting";
import { useController, useFormContext } from "react-hook-form";
import { MAX_TAG_COUNT } from "../../constants";
import TagsField from "shared/components/form/TagsField";
import { splitTags } from "../../helpers";
import { MAX_PLACES_TAG_COUNT } from "../../constants";

const TagSelect: FC<{ noLabel?: boolean }> = ({ noLabel }) => {
    const {
        t,
        i18n,
        i18n: { language },
    } = useTranslation();

    const { field: { value: selected = [], onChange } } = useController({ name: 'tags' });
    const { getValues, setValue } = useFormContext();

    const isGeograffee = AppTester.isGeograffee();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isBrnd = AppTester.isBrnd();

    const requiredTags = getValues('requiredTags');

    const isOneSelectedTag = selected?.length === 1
    return (
        <TagsField
            name="tags"
            label={t('project_edit.tags')}
            noLabel={noLabel}
            isProjectEdit
            isOneSelectedTag
            modalOptions={{
                educational: false,
                onChange: (tagsRaw: Tag[]) => {
                    if (isGeograffee) {
                        const { tags, cities } = splitTags(tagsRaw);
                        setValue('tags', tags);
                        setValue('cities', cities);
                    } else {
                        const tagIds = tagsRaw.map(tag => tag.tagId)
                        if (tagIds.length) {
                            TagsAPI.GetTags(({ tagIds, lang: i18n.language }))
                                .then((v) => v.json())
                                .then((v) => API.toLang<Tag[]>(v, language))
                                .then((tags) => onChange(tags));
                        }
                        onChange(tagsRaw);
                    }
                },
                hideGlobalSearchBar: isBrnd,
                maxEducationalTags: requiredTags?.length > 0 ? 0 : 1,
                maxProjectTags: MAX_TAG_COUNT,
                maxPlacesTags: MAX_PLACES_TAG_COUNT,
                protectedTags: isAgeytomesh ? [AGEYTOMESH_TAG_ID] : [],
            }}
        />
    );
};

export default TagSelect;